module.exports = __webpack_public_path__ + "static/service14-d435a77891ee87007438c330942a48e1.jpg";